import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import FontIcon from '../../atoms/FontIcon';
import Button from '../../atoms/Button';
import Content from '../../atoms/Content';
import PropertyControlledComponent from '../../molecules/PropertyControlledComponent';
var PaginationButton = function PaginationButton(props) {
  var changePage = props.changePage,
    pageNumber = props.pageNumber,
    isDisabled = props.isDisabled,
    isJumpButton = props.isJumpButton,
    hasLeftIcon = props.hasLeftIcon,
    buttonText = props.buttonText;
  var clickHandler = function clickHandler() {
    return changePage(pageNumber);
  };
  return /*#__PURE__*/React.createElement(Button, {
    className: cx('pagination-element pagination-element-button', {
      'is-disabled': isDisabled
    }, {
      'is-jump-button': isJumpButton && !isDisabled
    }),
    view: Button.VIEW.TERTIARY,
    onClick: clickHandler
  }, /*#__PURE__*/React.createElement(PropertyControlledComponent, {
    controllerProperty: hasLeftIcon
  }, /*#__PURE__*/React.createElement(FontIcon, {
    color: isDisabled ? 'ashGrey' : 'black',
    size: FontIcon.SIZES.S
  }, "icon-left-arrow-thin")), /*#__PURE__*/React.createElement(Content, {
    className: cx('text', {
      disabled: isDisabled,
      hasLeftIcon: hasLeftIcon
    })
  }, buttonText), /*#__PURE__*/React.createElement(PropertyControlledComponent, {
    controllerProperty: !hasLeftIcon
  }, /*#__PURE__*/React.createElement(FontIcon, {
    color: isDisabled ? 'ashGrey' : 'black',
    size: FontIcon.SIZES.S
  }, "icon-right-arrow-thin")));
};
PaginationButton.propTypes = {
  changePage: PropTypes.func.isRequired,
  pageNumber: PropTypes.number.isRequired,
  isDisabled: PropTypes.bool.isRequired,
  isJumpButton: PropTypes.bool,
  hasLeftIcon: PropTypes.bool,
  buttonText: PropTypes.string.isRequired
};
PaginationButton.defaultProps = {
  hasLeftIcon: false,
  isJumpButton: false
};
export default PaginationButton;